import { CANONICAL_ORIGIN } from '@/seo/marketing-routes';

/**
 * Canonical site origin for client-rendered metadata (canonical/hreflang/OG).
 *
 * Defaults to the production host and can be overridden per-environment with
 * `VITE_PUBLIC_SITE_URL` (e.g. a staging origin). The build-time sitemap plugin
 * and the Edge middleware use the plain `CANONICAL_ORIGIN` constant directly,
 * since `import.meta.env` is not available in those runtimes.
 */
export const SITE_URL: string =
  (import.meta.env?.VITE_PUBLIC_SITE_URL as string | undefined)?.replace(/\/$/, '') ??
  CANONICAL_ORIGIN;
